import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const ADDRESS_COORDINATES_SCHEMA = Object.freeze({
  LATITUDE: null,
  LONGITUDE: null,
  // other fields that we don't care about
});
const RECORD = generateSchema(ADDRESS_COORDINATES_SCHEMA);
const KEYS: any = generateKeys(ADDRESS_COORDINATES_SCHEMA);

export class AddressCoordinates extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get latitude(): number {
    return this.get(KEYS.LATITUDE);
  }

  get longitude(): number {
    return this.get(KEYS.LONGITUDE);
  }
}
